import { ViewpointBuilderFooter } from '../components/ViewpointBuilderFooter';
import { PrimaryButtonConfig } from '../openViewpointBuilder/getPrimaryButtonConfig';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { Island, ModalBodyLayout } from '@ardoq/page-layout';
import { Box } from '@ardoq/layout';
import {
  PerspectivesLabelFormattingWithMultiselect,
  MultiLabelFormattingProps,
} from '@ardoq/perspectives-sidebar';
import { t, type I18nLocale } from '@ardoq/i18n';

type FormattingContentProps = {
  closeViewpointBuilder: () => void;
  multiLabelFormattingProps: MultiLabelFormattingProps;
  primaryButtonConfig: PrimaryButtonConfig;
  i18nLocale: I18nLocale;
  // Commands are part of the state
};

export const LabelFormattingContent = ({
  multiLabelFormattingProps,
  closeViewpointBuilder,
  primaryButtonConfig,
  i18nLocale,
}: FormattingContentProps) => (
  <ModalBodyLayout
    footerContent={
      <ViewpointBuilderFooter
        closeViewpointBuilder={closeViewpointBuilder}
        primaryButtonConfig={primaryButtonConfig}
        i18nLocale={i18nLocale}
      />
    }
  >
    <Box padding="xlarge">
      <Island
        title={t(
          i18nLocale,
          'viewpointBuilder:labelFormatting.title',
          'Labels'
        )}
        subtitleWidth="large"
        subtitle={t(
          i18nLocale,
          'viewpointBuilder:labelFormatting.subtitle',
          'Show field values on specific component and reference types. Component name is shown by default.'
        )}
        knowledgeBaseLink={KnowledgeBaseLink.LABEL_FORMATTING}
      >
        <PerspectivesLabelFormattingWithMultiselect
          {...multiLabelFormattingProps}
          isHorizontal
        />
      </Island>
    </Box>
  </ModalBodyLayout>
);
